// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"266":"current-seminar","687":"archive-2025","838":"archive-2023"}[chunkId] || chunkId) + "." + {"266":"c94d1448","687":"132b05d5","838":"ab412d51","895":"36c18fce"}[chunkId] + ".css";
};